export const confirmActionContainerStyles = {
  display: 'flex',
  width: '100%',
  gap: '8px',
  marginTop: '8px',
};

export const confirmActionButtonStyles = {
  flex: 1,
};
